import {Injectable} from "@angular/core";
import {CostsOfLivingApi} from "../../src/app/shared/sdk/services/custom/CostsOfLiving";

@Injectable()
export class CostOfLivingUtils {

  constructor(protected costsOfLivingApi: CostsOfLivingApi) {}

  public loadBCostsOfLiving() {
    return this.costsOfLivingApi.findOne();
  }
}



// WEBPACK FOOTER //
// ./common/utils/costoflivingutils.ts